import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service';
import { Activity } from './activity';
import { faRunning, faClock, faRoad } from '@fortawesome/free-solid-svg-icons';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.css']
})
export class ActivityComponent implements OnInit {

  listActivitys = new Array();
  constructor(private dashboardService : DashboardService, public _snackBar: MatSnackBar) { }

  faRunning = faRunning;
  faClock = faClock;
  faRoad = faRoad;
  loading = false;
  page = 1;
  showMoreActivitys = false;
  showMoreActivitysLoading = false;

  ngOnInit(): void {
    this.getActivitys(this.page);
  }

  loadMoreActivitys(){
    this.page += 1;
    this.getActivitys(this.page);
  }

  checkMoreActivitys(){
    this.showMoreActivitys = ((this.listActivitys.length % 5)  == 0) && this.listActivitys.length != 0;
  }

  getActivitys(pageNumber : number): void {
      var that = this;
      this.showMoreActivitysLoading = true;

      this.dashboardService.getActivitys(pageNumber)
      .subscribe(activitys => {

        activitys.forEach(activity => {
          that.listActivitys.push(activity);
        });
        this.displayRemove();
        this.checkMoreActivitys();
      },
      (err) => {
        this.showMoreActivitysLoading = false;
      },
      ()=>{
        this.showMoreActivitysLoading = false;
      });
  }

  async deleteRun(idRun, idActivity){
    this.loading = true;
    let that = this;
    await this.dashboardService.deleteActivity(idRun)
        .subscribe(res => {},
        err => {
          this.loading = false;
          that._snackBar.open('An error occured.', 'Close', {
            duration: 3000
          });
        },
        () => {
                this.loading = false;
                this.listActivitys.forEach((activity, index)=>{
                  if(activity._id == idRun){
                    this.listActivitys.splice(index,1)
                  }
                })

                that._snackBar.open('The activity has been removed. Please reload to see changes.', 'Close', {
                  duration: 3000
                });
              }
        );

        
  }

  
  displayRemove(){
    this.listActivitys.forEach(element => {
      let dateNow = new Date();
      let dateTimeCreation = new Date(element.dateTimeCreation);
      dateTimeCreation.setMinutes(dateTimeCreation.getMinutes() + 60);

      if(dateTimeCreation > dateNow)
        element.displayRemove = true;
        
    });
  }

}
